import React from 'react';
import { checkPercentType, formatValue, getMaxQuantity, getValueDisplay } from './utils';
import {
  ADD_ON_FEE_TYPE_VALUE,
  ADD_ON_UNIT_VALUE,
} from '../../../containers/settings/AddonTemplate/utils/fieldAddonService';
import EditableNumber from './EditableNumber';
import currencyFormatter from 'currency-formatter';
const AddonItem = ({
  item,
  entry,
  hideActionButtons = false,
  isIncluded = false,
  onQuantityChange,
  onCustomValueChange,
  onValueEditFareChange,
  isEditFare = false, // in edit fare modal
  hideEnableButton = false,
  currencyISO,
  disabled = false
}) => {
  const quantity = entry?.quantity || 0;
  const maxQuantity = getMaxQuantity(item);
  const minusDisabled = quantity <= 0;
  const plusDisabled = Number.isFinite(maxQuantity) && quantity >= maxQuantity;
  const showCustomInput =
    item?.feeConfig?.type === ADD_ON_FEE_TYPE_VALUE.custom;

  const renderValueField = () => {
    const getValueEditField = () => {
      if(!entry) return 0;
      if (_.isNumber(entry?.editedValue)) {
        return entry?.editedValue;
      }
      
      if (showCustomInput) {
        return entry?.customValue;
      }


      return getValueDisplay(entry, entry?.feeConfig?.value, currencyISO) || 0;
    };

    const checkShowValue = () => {
      if (isIncluded && item?.feeConfig?.unit !== ADD_ON_UNIT_VALUE.each) {
        return false;
      }
      return true;
    };

    if (isEditFare) {
      return (
        <EditableNumber
          value={getValueEditField()}
          onChange={(value) => onValueEditFareChange(item, value)}
          valueDisplay={
            checkPercentType(item)
              ? `${getValueEditField()}%`
              : currencyFormatter.format(getValueEditField(), {
                  code: currencyISO,
                })
          }
          disabled={disabled}
        />
      );
    }
    return (
      <>
        {showCustomInput ? (
          <EditableNumber
            value={entry?.customValue || ''}
            onChange={(value) => onCustomValueChange(item, value)}
            valueDisplay={
              checkPercentType(item)
                ? `${entry?.customValue}%`
                : currencyFormatter.format(entry?.customValue, {
                    code: currencyISO,
                  })
            }
            max={
              item?.feeConfig?.isUnlimited ? undefined : item?.feeConfig?.value
            }
            disabled={disabled}
          />
        ) : checkShowValue() ? (
          <div className="addon-item__value">{formatValue(item, currencyISO)}</div>
        ) : null}
      </>
    );
  };

  return (
    <div className="addon-item">
      <div className="addon-item__header">
        <div className="addon-item__name">{item.name}</div>
        {renderValueField()}
      </div>
      <div className="addon-item__body">
        <div className="addon-item__description">{item.description}</div>
        {!hideActionButtons &&
          !showCustomInput &&
          (!hideEnableButton ||
            (hideEnableButton &&
              item.feeConfig?.unit === ADD_ON_UNIT_VALUE.each)) && (
            <div className="addon-item__controls">
              <button
                type="button"
                className={`addon-item__btn ${minusDisabled ? 'disabled' : ''}`}
                onClick={() => onQuantityChange(item, -1)}
                disabled={minusDisabled || disabled}
                aria-label="Decrease quantity"
              >
                –
              </button>
              <div className="addon-item__quantity">{quantity}</div>
              <button
                type="button"
                className={`addon-item__btn ${plusDisabled ? 'disabled' : ''}`}
                onClick={() => onQuantityChange(item, 1)}
                disabled={plusDisabled || disabled}
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>
          )}
      </div>
      {!hideActionButtons && <div className="addon-divider" />}
    </div>
  );
};

export default AddonItem;
